export default "__VITE_ASSET__ef1a5b6d__"